module.exports = __webpack_public_path__ + "img/photo-0099.a49c3718.jpg";